(function () {
  if (window.aonaShopSessionWatcher) return;
  window.aonaShopSessionWatcher = true;
  var deadline = 0, timer = null, checking = false, navigating = false;
  function destination() {
    var params = new URLSearchParams(location.search);
    var raw = params.get('checkout_url') || params.get('return_to') || params.get('return_url');
    try {
      if (!raw && (sessionStorage.getItem('aona_pending_buy_now') === 'true' || document.cookie.indexOf('aona_buy_now=true') !== -1)) raw = '/checkout';
    } catch (_) {}
    if (raw && raw.charAt(0) === '/' && raw.charAt(1) !== '/' && !/[\\\r\n]/.test(raw)) {
      var target = new URL(raw, location.origin);
      if (target.origin === location.origin && !/^\/account\/(login|register|logout)(?:\/|$)/.test(target.pathname)) return target.pathname + target.search + target.hash;
    }
    return '/account';
  }
  async function check() {
    if (checking || navigating || Date.now() > deadline || document.hidden) return;
    checking = true;
    try {
      var url = new URL('/', location.origin);
      url.searchParams.set('view', 'aona-shop-session');
      url.searchParams.set('_aona_session', String(Date.now()));
      var preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      var response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (response.ok && /application\/json|text\/html/i.test(response.headers.get('content-type') || '')) {
        var state = await response.json();
        // Only the Shopify-rendered session decides success. No local profile or Shop message grants access.
        if (state.authenticated === true) {
          navigating = true;
          if (timer) clearTimeout(timer);
          location.replace(destination());
        }
      }
    } catch (_) {
      // Cancellation, expiry and network failures leave the login window available.
    } finally {
      checking = false;
      if (!navigating && Date.now() < deadline) timer = setTimeout(check, 2000);
    }
  }
  document.addEventListener('click', function (event) {
    if (!event.composedPath().some(function (el) { return el.tagName === 'SHOP-LOGIN-BUTTON'; })) return;
    deadline = Date.now() + 180000;
    if (timer) clearTimeout(timer);
    check();
  }, true);
  window.addEventListener('focus', function () { if (timer) clearTimeout(timer); check(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { if (timer) clearTimeout(timer); check(); } });
})();
